import { GetterTree } from 'vuex';
import { AuthenticationState, User } from './types';
import { RootState } from '@/types';

export const getters: GetterTree<AuthenticationState, RootState> = {
    jwt(state): string {
        const jwt  = state.jwt || '';
        return jwt;
    },
    user(state): User | undefined {
        return state.user;
    },
    error(state): boolean {
        return state.error;
    },
};
